module.exports = __webpack_public_path__ + "img/upload-violet.884d05b5.svg";